import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n);

//{{ $t("app.emaillabel", {name: user.prenom.concat(' ', user.nom), email:user.email}) }}
//{{ $t("app.emaillabel") }}
//this.$i18n.locale
//$i18n.locale

export const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en: {
      title: {
        user: "User",
        prospect: "Add a prospect",
        EditProspect: "Update a prospect",
        menu: "Menu",
        unitstable: "List of units by property",
        unitslist: "Units list",
        app: "Prospect Tracking",
        prospectslist:"Prospects List",
        list0: "Vacant without income",
        list1: "Departure | Departures",
        unitsfor: "List of units for ",
        lang: "Language",
        statusform: "Status form",
        footer: "Footer",
        selectedunits: "Selected unit | Selected units",
        selectedunitsFor: "Selected unit(s) for {0}",
        linkUnitProspect: "Link unit to prospect",
        confirmation: "Confirmation",
        followup: "Follow-up",
        EmailRegistration: "Form"
        /**/
      },
      label: {
        report: "Report",
        genders: {"m": "Man", "w": "Woman", "o": "Other"},
        fullname: "Full name",
        fname: "First name",
        lname: "Last name",
        email: "Email",
        all: "All",
        tel: "Phone",
        date: "Creation",
        gender: "Gender",
        language: "Language",
        properties: "Properties",
        property: "Property",
        man: "Man",
        woman: "Woman",
        other: "Other",
        languages: {"fr" : "French", "en" : "English"},
        french: "French",
        english: "English",
        type: "Contact type",
        calendar: "Calendar",
        credit: "Credit",
        location: "Location contract",
        facetoface: "In person",
        emailtype: "By email",
        phonetype: "By phone",
        tablesize: "Number of entries in the table : ",
        building:"Building",
        dateFrom: "Date from",
        dateTo: "Date to",
        unitlabel:"Unit | Units",
        nbpieceslabel: "Rooms",
        dateexplabel: "Exp",
        datedeplabel: "Dep",
        status: "Status",
        statusType: "Status type",
        nbrunit: "Total of units",
        nbrvacant: "Vacant unit(s)",
        renttotal: "Rented total",
        percentage: "Percentage",
        vacantdepuis: "Vacant since",
        vacantfutur: "Will be vacant",
        codeocc: "Occ",
        datedep: "Departure",
        signed: "Signed lease",
        application: "Application",
        notready: "Not ready",
        unitinfo: "Unit information",
        locationinfo: "Location Information",
        prospectinfo: "Prospect Information",
        noprospect: "No prospect",
        //UnitPanel
        floor: "Floor(s)",
        surface: "Surface",
        orientation: "Orientation",
        market: "Market value",
        loyact: "Current rent",
        loyevent: "Possible rent",
        expdate: "Expiration date",
        calendarinvite: "Send a meeting request",
        visit: "Unit visit",
        rented: "Unit rented",
        region: "Area",
        appartement: "Appartment",
        meaning: "GIVE SENSE TO REAL ESTATE"
      },
      action: {
        login: "Sign in",
        logout: "Sign out",
        add: "Add",
        clearField: "Clear field",
        show: "Show",
        hide: "Hide",
        addProspect: "Add a prospect",
        choose: "Choose",
        chooseDate: "Choose a date",
        selected: "Selected",
        report: "Get a report",
        search:"Search",
        returntohomepage: "Return to home page",
        submit: "Submit",
        addstatus: "Add a status",
        addfollowup: "Add follow-up",
        choosefile: "Choose a file",
        suivi: "Follow up",
        infobuilding: "Unit Information",
        change: "Change",
        confirmed: "To confirm",
        rentedCheckbox: "The prospect <strong> {0} </strong> has rented the apartment {1}",
        edit: "Edit",
        addUnits: "Add units",
        delete: "Delete"
      },
      info: {
        successgeneric: "Your information has been processed succesfully",
        emailexist: "This email is already register in our system.",
        months : 'January_February_March_April_May_June_July_August_September_October_November_December',
        required: "This field is required",
        email: "This email address is not valid",
        tel: "A phone number should only contain numbers",
        maxLength: "This field is limited to {0} characters",
        units: "You must choose at least one unit",
        errorgeneric: "An error has occurred : {0}",
        errorfile: "Error in file upload",
        textConfirmed: "Press the button below to confirm that the prospect <br> <strong> {0} </strong> <br> has rented the apartment {1}",
        removeConfirmed: "Press the button below to confirm that the prospect <strong> {0} </strong> <br> is unlinked from the apartment {1}",
        removeConfirmedProspect: "Press the button below to confirm the deletion of the prospect <strong> {0} </strong>",
        consent: "I wish to receive news, promotions and events relating to the building and Cogir Real Estate.",
        form: "The information collected via this form is strictly confidential.",
        alertcountdown: "This alert will dismiss after {0} seconds..."
      },
    },
    fr: {
      title: {
        user: "Utilisateur",
        prospect: "Ajouter un candidat",
        EditProspect: "Modifier un candidat",
        menu: "Menu",
        unitstable: "Liste des unités par propriété",
        unitslist: "Liste des unités",
        app: "Suivi des candidats",
        prospectslist:"Liste des candidats",
        list0: "Vacants sans revenu",
        list1: "Départ | Départs",
        unitsfor: "Liste des unités pour ",
        lang: "Langue",
        statusform: "Formulaire ajout d'un statut",
        footer: "Pied de page",
        selectedunits: "Unité choisie | Unités choisies",
        selectedunitsFor: "Unité(s) choisie(s) pour {0}",
        linkUnitProspect: "Associer unité à un prospect",
        confirmation: "Confirmation",
        followup: "Suivi",
        EmailRegistration: "Formulaire"
        /**/
      },
      label: {
        report: "Rapport",
        genders: {"m": "Homme", "w": "Femme", "o": "Autre"},
        fullname: "Nom complet",
        fname: "Prénom",
        lname: "Nom",
        email: "Courriel",
        all: "Tous",
        tel: "Téléphone",
        date: "Création",
        gender: "Genre",
        language: "Langue",
        properties: "Propriétés",
        property: "Propriété | Propriétés",
        man: "Homme",
        woman: "Femme",
        other: "Autre",
        languages: {"fr" : "Français", "en" : "Anglais"},
        french: "Français",
        english: "Anglais",

        type: "Type de contact",
        calendar: "Calendrier",
        credit: "Crédit",
        location: "Contrat de location",
        facetoface: "En personne",
        emailtype: "Par courriel",
        phonetype: "Par téléphone",
        tablesize: "Nombre d'entrées dans la liste : ",

        unitlabel:"Unité | Unités",
        building:"Immeuble",
        dateFrom: "Date de début",
        dateTo: "Date de fin",
        nbpieceslabel: "Pièces",
        dateexplabel: "Exp",
        datedeplabel: "Dep",

        status: "Statut",
        statusType: "Type de statut",
        nbrunit: "Nombre de logement",
        nbrvacant: "Total vacant(s)",
        renttotal: "Total loué(s)",
        percentage: "Pourcentage",
        vacantdepuis: "Vacant depuis",
        vacantfutur: "Sera vacant",
        codeocc: "Occ",
        datedep: "Départ",
        signed: "Bail signé",
        application: "Application",
        notready: "Pas prêt",
        unitinfo: "Information sur l'unité",
        locationinfo: "Information sur la location",
        prospectinfo: "Information sur le(s) candidat(s)",
        noprospect: "Aucun candidat",

        //UnitPanel
        floor: "Étage(s)",
        surface: "Superficie",
        orientation: "Orientation",
        market: "Valeur du marché",
        loyact: "Loyer actuel",
        loyevent: "Loyer éventuel",
        expdate: "Date d'expiration",
        calendarinvite: "Envoyer une invitation de calendrier",
        visit: "Visite de l'unité",
        rented: "Unité loué",
        region: "Région",
        appartement: "Appartement",
        meaning: "DONNER UN SENS À L’IMMOBILIER"
      },
      action: {
        login: "S'identifier",
        logout: "Déconnexion",
        add: "Ajout",
        clearField: "Vider les champs",
        show: "Ouvrir",
        hide: "Fermer",
        addProspect: "Ajouter un candidat",
        choose: "Choisir",
        chooseDate: "Choisir une date",
        selected: "Choisie",
        report: "Obtenir un rapport",
        search:"Chercher",
        returntohomepage: "Retour à l'accueil",
        submit: "Soumettre",
        addstatus: "Ajouter un statut",
        choosefile: "Choisir un fichier",
        suivi: "Suivi",
        infobuilding: "Information sur l'unité",
        change: "Change",
        confirmed: "Confirmer",
        addfollowup: "Ajouter un suivi",
        rentedCheckbox: "Le prospect <strong> {0} </strong> a loué l'appartement {1}",
        edit: "Modifier",
        addUnits: "Ajouter des unités",
        delete: "Supprimer"
      },
      info: {
        successgeneric: "Vos informations ont été soumises avec succès",
        errorgeneric: "Une erreur s'est produite : {0}",
        emailexist: "Cette adresse courriel se trouve déjà dans notre système.",
        months : 'Janvier_Février_Mars_Avril_Mai_Juin_Juillet_Août_Septembre_Octobre_Novembre_Décembre',
        required: "Ce champs est requis",
        email: "Cette adresse courriel n'est pas valide",
        tel: "Un numéro de téléphone doit seulement contenir des nombres",
        maxLength: "Ce champ est limité à {0} charactères",
        units: "Vous devez choisir une ou plusieurs unités",
        errorfile: "Le fichier téléversé n'est pas valide",
        textConfirmed: "Appuyez sur le bouton ci-dessous pour confirmer que le prospect <br> <strong> {0} </strong> <br> a loué l'appartement {1}",
        removeConfirmed: "Appuyez sur le bouton ci-dessous pour confirmer que le prospect <br> <strong> {0} </strong> <br> est dissocié de l'appartement {1}",
        removeConfirmedProspect: "Appuyez sur le bouton ci-dessous pour confirmer la suppression du prospect <strong> {0} </strong>",
        consent: "Je désire recevoir des nouvelles, des promotions et des événements à propos de l’immeuble et de Cogir immobilier.",
        form: "Les informations collectées via ce formulaire sont strictement confidentielles.",
        alertcountdown: "Cette alerte va disparaître dans {0} seconde(s)..."
      }
    }
  }
})
